var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import styled from 'styled-components';
import DropdownIcon from '@assets/svg/dropDownIcon.svg';
import CenterModal from '@/components/CenterModal/CenterModal';
import Loader from '@/components/Loader/Loader';
var MenuItem = function (_a) {
    var menu = _a.menu, handleDelete = _a.handleDelete, isLoading = _a.isLoading, menuThumbnails = _a.menuThumbnails, index = _a.index;
    var _b = useState({
        modalIsOpen: false,
        centerModalShow: false,
        imageToShow: '',
        isDeleting: false // New state to track if delete action has been initiated
    }), state = _b[0], setState = _b[1];
    var handleIconClick = useCallback(function (e) {
        e.stopPropagation();
        setState(function (prevState) { return (__assign(__assign({}, prevState), { modalIsOpen: !prevState.modalIsOpen })); });
    }, []);
    var handleModalClick = useCallback(function (e) {
        e.stopPropagation();
        setState(function (prevState) { return (__assign(__assign({}, prevState), { centerModalShow: true, imageToShow: menuThumbnails, isDeleting: false })); });
    }, [menuThumbnails]);
    var handleDeleteClick = useCallback(function (e) {
        e.stopPropagation();
        setState(function (prevState) { return (__assign(__assign({}, prevState), { centerModalShow: true, imageToShow: menuThumbnails, isDeleting: true })); });
    }, [menuThumbnails]);
    var handleClose = useCallback(function () {
        setState({ modalIsOpen: false, centerModalShow: false, imageToShow: '', isDeleting: false });
    }, []);
    console.log(menuThumbnails, '88888menuThumbnails88888menuThumbnails88888menuThumbnails');
    var handleDeletePress = useCallback(function (e) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.stopPropagation();
                        setState(function (prevState) { return (__assign(__assign({}, prevState), { isDeleting: true })); }); // Set isDeleting to true before delete action
                        return [4 /*yield*/, handleDelete()];
                    case 1:
                        _a.sent();
                        handleClose();
                        return [2 /*return*/];
                }
            });
        });
    }, [handleDelete, handleClose]);
    return (_jsxs(ArrayItem, { children: [_jsx(PhotoPreviewContainer, __assign({ onClick: handleModalClick }, { children: (menuThumbnails === null || menuThumbnails === void 0 ? void 0 : menuThumbnails.props) ? menuThumbnails : (menuThumbnails ? _jsx("img", { src: menuThumbnails, alt: "Page Preview" }) : _jsx("div", { children: "No preview available" })) })), _jsx(ItemText, { children: menu.fileName }), _jsx(IconContainer, __assign({ isShow: state.modalIsOpen, onClick: handleIconClick }, { children: _jsx(DropdownIcon, {}) })), _jsx(Modal, __assign({ isShow: state.modalIsOpen, onClick: handleDeleteClick }, { children: _jsx("span", __assign({ style: modalTextStyle }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) })), _jsx(CenterModal, __assign({ show: state.centerModalShow, handleClose: handleClose }, { children: !state.isDeleting && state.imageToShow ? (_jsx("img", { src: state.imageToShow, alt: "Preview", style: { maxWidth: '100%', maxHeight: '100%' } })) : (_jsxs("div", { children: [_jsx("p", __assign({ style: modalTitleStyle }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C?" })), _jsx("p", __assign({ style: modalDescStyle }, { children: "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0444\u0430\u0439\u043B?" })), _jsxs(ButtonContainer, { children: [_jsx(Button, __assign({ onClick: handleDeletePress }, { children: isLoading ? _jsx(Loader, { width: '20px', height: '20px' }) : _jsx("span", __assign({ style: buttonTextStyle }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) })), _jsx("span", __assign({ onClick: handleClose, style: cancelTextStyle }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" }))] })] })) }))] }, menu.id));
};
var modalTextStyle = {
    color: '#EB5757',
    fontFamily: 'Montserrat Regular',
    fontWeight: 400,
    fontSize: '16px',
    cursor: 'pointer',
};
var modalTitleStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 500,
    fontSize: '20px',
};
var modalDescStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 400,
    fontSize: '14px',
    marginBottom: '40px',
};
var buttonTextStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 500,
    fontSize: '16px',
};
var cancelTextStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 500,
    fontSize: '16px',
    marginLeft: '40px',
    cursor: 'pointer',
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n     position: relative;\n    display: flex;\n    align-items: center;\n    padding: 0 4vw;\n    padding-left: 1vw;\n    height: 116px;\n    background: #fff;\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-bottom: ", ";\n    @media (max-width: 768px) {\n        flex-direction: column;\n        height: auto;\n        padding: 2vw;\n    }\n"], ["\n     position: relative;\n    display: flex;\n    align-items: center;\n    padding: 0 4vw;\n    padding-left: 1vw;\n    height: 116px;\n    background: #fff;\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-bottom: ", ";\n    @media (max-width: 768px) {\n        flex-direction: column;\n        height: auto;\n        padding: 2vw;\n    }\n"])), function (props) { return (props.isFirst ? '8px' : '0'); }, function (props) { return (props.isFirst ? '8px' : '0'); }, function (props) { return (props.isLast ? '8px' : '0'); }, function (props) { return (props.isLast ? '8px' : '0'); }, function (props) { return (props.isLast ? 'none' : '1px solid #E3E3E3'); });
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: auto;\n    width: 32px;\n    display: flex;\n    height: 32px;\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    margin-right: 46px;\n    border-radius: 50%;\n    cursor: pointer;\n"], ["\n    margin-left: auto;\n    width: 32px;\n    display: flex;\n    height: 32px;\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    margin-right: 46px;\n    border-radius: 50%;\n    cursor: pointer;\n"])), function (props) { return (props.isShow ? '#E2E2E2' : 'none'); });
var Modal = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    right: 4vw;\n    top: 80px;\n    background-color: #fff;\n    border: 1px solid #E3E3E3;\n    border-radius: 8px;\n    display: ", ";\n    z-index: 2;\n    padding: 16px;\n    box-shadow: 0px 4px 4px 0px #0000001A;\n"], ["\n    position: absolute;\n    right: 4vw;\n    top: 80px;\n    background-color: #fff;\n    border: 1px solid #E3E3E3;\n    border-radius: 8px;\n    display: ", ";\n    z-index: 2;\n    padding: 16px;\n    box-shadow: 0px 4px 4px 0px #0000001A;\n"])), function (props) { return (props.isShow ? 'block' : 'none'); });
var ButtonContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    margin: 10px 0;\n    align-items: center;\n    justify-content: center;\n"], ["\n    display: flex;\n    margin: 10px 0;\n    align-items: center;\n    justify-content: center;\n"])));
var Button = styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: block;\n    padding: 15px 15px;\n    background-color: #EB5757;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: #f34040;\n    }\n"], ["\n    display: block;\n    padding: 15px 15px;\n    background-color: #EB5757;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: #f34040;\n    }\n"])));
var ArrayItem = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    cursor: pointer;\n     position: relative;\n     flex-direction: row;\n     text-align: center;\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    height: 116px;\n    width: 100%;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n"], ["\n    cursor: pointer;\n     position: relative;\n     flex-direction: row;\n     text-align: center;\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    height: 116px;\n    width: 100%;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n"])));
var PhotoPreviewContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    img {\n        object-fit: cover;\n        max-width: 200px;\n        max-height: 108px;\n        border-radius: 8px;\n    }\n"], ["\n    img {\n        object-fit: cover;\n        max-width: 200px;\n        max-height: 108px;\n        border-radius: 8px;\n    }\n"])));
var ItemText = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    color: #000000;\n    align-self: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &:first-child {\n        flex: 0 0 20vw;\n        @media (max-width: 768px) {\n            flex: 0 0 auto;\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n\n    &:nth-child(2) {\n        flex: 1;\n        @media (max-width: 768px) {\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n"], ["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    color: #000000;\n    align-self: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &:first-child {\n        flex: 0 0 20vw;\n        @media (max-width: 768px) {\n            flex: 0 0 auto;\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n\n    &:nth-child(2) {\n        flex: 1;\n        @media (max-width: 768px) {\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n"])));
export default MenuItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
